<template>
    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.514937 11.876C2.18551 10.1041 4.47016 9.00001 7 9.00001C9.52985 9.00001 11.8145 10.1041 13.4851 11.876C13.6676 12.0696 13.7175 12.3532 13.6121 12.5975C13.5067 12.8418 13.2661 13 13 13H1C0.733926 13 0.493329 12.8418 0.387902 12.5975C0.282474 12.3532 0.332408 12.0696 0.514937 11.876Z" :fill="color"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.33334 4.00001C3.33334 1.97497 4.97496 0.333344 7 0.333344C9.02505 0.333344 10.6667 1.97497 10.6667 4.00001C10.6667 6.02505 9.02505 7.66668 7 7.66668C4.97496 7.66668 3.33334 6.02505 3.33334 4.00001Z" :fill="color"/>
    </svg>
</template>

<script>
    export default {
        name: 'UserIcon',
        props: {
            color: {
                type: String,
                default: '#000000',
                required: false
            }
        },
        data() {
            return {
                
            }
        }
    }
</script>